import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import ErrorIcon from '@mui/icons-material/Error'

import { theme } from '../../themes/theme'
import { FlexColumn, FlexRow, Divider } from '../styles/Containers'
import { BoldSpan, MedBodyText } from '../styles/Text'
import BrowserFile from './BrowserFile'

const Column = styled(FlexColumn)`
  padding: 15px;
  border-radius: ${theme.borderRadius.div};
  border: 1px solid ${theme.colors.error};
`

const ErrorWrapper = styled(FlexRow)`
  align-items: center;
  gap: 15px;

  .MuiSvgIcon-root {
    color: ${theme.colors.error};
    width: 18px;
    height: 18px;
  }
`

const FailedBrowserUploadList = ({ files }) => (
  <>
    {files.length > 0 && (
      <Column>
        <ErrorWrapper>
          <ErrorIcon />
          <MedBodyText>
            The following <BoldSpan>{files.length} files </BoldSpan>could not be uploaded:
          </MedBodyText>
        </ErrorWrapper>
        <FlexColumn gap="0">
          {files.map(f => {
            return (
              <FlexColumn key={f.name} gap="0">
                <Divider />
                <BrowserFile file={f} showButton={false} spacing="minimal" />
              </FlexColumn>
            )
          })}
          <Divider />
        </FlexColumn>
      </Column>
    )}
  </>
)

FailedBrowserUploadList.propTypes = {
  files: PropTypes.array.isRequired
}

export default FailedBrowserUploadList
